import React from 'react'
import moment from 'moment'
import cl from 'classnames'
import swal from "sweetalert2"
import Modal from 'components/Modal'
import lodash from 'lodash'
import { smoothScroll, formatNumber, img, commingSoonFnc, isStartEvent, particleRed, particleBlue, particlePurple } from 'components/common'
import ReactTooltip from 'react-tooltip'
class MissionSection extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            modal: null,
            isMobile: false,
            promotion_info: null,
            max_topup: 0,
            topup: 0,
            desc: '',
            isOpening: -1,
        }
    }
    handleClosePopup() {
        this.setState({ modal: null })
        $('body').removeClass('modal-open');
    }
    handleOpenPopup(modal) {
        this.setState({ modal: modal })
        $('body').addClass('modal-open');
    }
    componentDidMount() {
        if ($(window).width() < 1023) {
            this.setState({
                isMobile: true,
            })
        }
        // particlesJS("test-praticle", particlePurple);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.parentProp.home.promotion_info != null && !nextProps.parentProp.home.loading) {
            this.setState({
                promotion_info: nextProps.parentProp.home.promotion_info,
                max_topup: nextProps.parentProp.home.promotion_info.max_topup,
                desc: nextProps.parentProp.home.promotion_info.desc,
            })
        }
        if (nextProps.parentProp.home.user != null && !nextProps.parentProp.home.loading) {
            this.setState({
                topup: nextProps.parentProp.home.user.topup,
                promotion_stage_histories: nextProps.parentProp.home.user.promotion_stage_histories,
            })
        }
    }
    onClaimStage(promotion_info_id, stage) {
        this.setState({
            isOpening: stage
        })
        this.props.parentProp.calimMedal(promotion_info_id, stage, this.callBackOpen.bind(this))
    }
    callBackOpen() {
        this.setState({
            isOpening: -1,
        })
        setTimeout(() => {
            swal({
                title: 'Thông báo',
                html: '<p class="pop-content">Nhận quà thành công. Quà sẽ gửi đến hòm thư của bạn trong 24h.</p>',
                animation: false,
                confirmButtonText: 'Đóng',
                customClass: 'custom-modal animated zoomIn'
            })
        }, 2500);
    }
    renderButton(promotion) {
        if (!promotion || !this.state.topup) {
            return (<a href="javascript:void(0)" className="act-btn prevent-click">
            {img('images/btn_nhan.png')}
        </a>) 
        }
        if (this.state.topup >= promotion.stage) {
            if (!this.state.promotion_stage_histories) {
                return (<a href="javascript:void(0)" className="act-btn" onClick={e => this.onClaimStage(this.state.promotion_info.id, promotion.stage)}>
                    {img('images/btn_nhan.png')}
                </a>)
            }
            else {
                let result = this.state.promotion_stage_histories.find(obj => { return obj.stage === promotion.stage })
                if (result) {
                    return (<a href="javascript:void(0)" className="act-btn no-click">
                        {img('images/btn_danhan.png')}
                    </a>)
                }
                else {
                    return (<a href="javascript:void(0)" className="act-btn" onClick={e => this.onClaimStage(this.state.promotion_info.id, promotion.stage)}>
                        {img('images/btn_nhan.png')}
                    </a>)
                }
            }

        }
        else {
            return (<a href="javascript:void(0)" className="act-btn prevent-click">
                {img('images/btn_nhan.png')}
            </a>)
        }
    }
    checkClassBox(promotion) {
        if (!promotion || !this.state.topup) {
            return ''
        }
        if (this.state.topup >= promotion.stage) {
            if (!this.state.promotion_stage_histories) {
                return 'is-claimable'
            }
            else {
                let result = this.state.promotion_stage_histories.find(obj => { return obj.stage === promotion.stage })
                if (result) {
                    return 'open'
                }
                else {
                    return 'is-claimable'
                }
            }
        }
        else {
            return ''
        }
    }
    checkProgress(idx) {
        let w = 0
        if (idx == 0) {
            w = this.state.topup / 0.4
        }
        else if (idx == 1) {
            w = this.state.topup / 1
        }
        else if (idx == 2) {
            w = this.state.topup / 2
        }
        let styles = {
            width: w + '%'
        }
        return styles
    }
    render() {
        const { modal, isMobile, promotion_info, desc, isOpening } = this.state
        return (
            <React.Fragment>
                <section className="mission-section">
                    <h4 className="title">
                        <div className="main-tit">{img('images/title.png')}</div>
                        <div className="sologan">{img('images/t-event.png')}</div>
                    </h4>
                    <p className="date">thời gian : {desc} <br/> <i>Lưu ý: Chỉ 1 lần duy nhất </i></p>

                    <div className="wrap-promotion">
                        <ul className="claim-target">
                            {
                                promotion_info && promotion_info.id &&
                                promotion_info.stages.map((item, index) => (
                                    <li key={'pi_' + index} className={`${isOpening == item.stage ? 'is-open' : ''} ${this.checkClassBox(item)}`}>
                                        <div className="img-avt" data-tip='' data-for={`pop-tooltip-` + index}>
                                            {img('images/box-1.png', 'base')}
                                            {img('images/nap_' + (index + 1) + '.png', 'nap')}
                                            {img('images/than_' + (index + 1) + '.png', 'than')}
                                        </div>
                                        <div className="tg-fc">{item.stage} mc</div>
                                        {
                                            this.renderButton(item)
                                        }
                                    </li>
                                ))
                            }
                        </ul>
                        <div className="progress-sc">
                            {
                                promotion_info &&
                                promotion_info.stages.map((item, idx) => (
                                    <div key={'prg_' + idx} className="pbbar">
                                        <span style={this.checkProgress(idx)}></span>
                                    </div>
                                ))
                            }
                        </div>
                        {
                            promotion_info &&
                            promotion_info.stages.map((item, idx) => (
                                item.image &&
                                <ReactTooltip place="left" type="light" effect="float" id={`pop-tooltip-` + idx}>
                                    <div className="product-des">
                                        <h4 className="pd-name">Quà có thể nhận</h4>
                                        <ul>
                                            {
                                                item.image.split('|').map((gift, ix) => (
                                                    <li key={ix}>
                                                        <span><img src={gift.split(';')[1]} alt="" /></span>
                                                        <span>{gift.split(';')[0]}</span>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </ReactTooltip>
                            ))
                        }
                    </div>
                </section>
                <Modal show={modal === 'chose-gift'} customClass={'pop-xs'} closeHandler={() => this.handleClosePopup()}>
                    <div className="fire-success">
                        <h3 className="md-header">Chọn phần thưởng</h3>
                    </div>
                </Modal>
            </React.Fragment>
        )
    }
}

export default MissionSection



// WEBPACK FOOTER //
// ./src/components/event/MissionSection.js